import {entityConfigFeatureKey, selectAll, selectEntities} from './entity-configuracao.reducer';
import {selectors} from '~utils/ngrx-util';
import {createSelector} from '@ngrx/store';
import {emptyParametros} from '~model/vo/parametros-vo';
import {emptyTiposIncidentes} from '~model/vo/tipos-incidentes-vo';
import {Map} from 'immutable';
import { entityConfigVoid } from './entity-configuracao.model';

const {
  entitySelectAll,
  entitySelectEntities,
  entitySelectById,
} = selectors(entityConfigFeatureKey, {selectAll, selectEntities});

export const entityConfigSelectAll = entitySelectAll;
export const entityConfigSelectEntities = entitySelectEntities;
export const entityConfigSelectById = entitySelectById;

export const defaultCamposGrid: string[] = ['placa', 'nomeRota', 'identificador'];

const byId = entitySelectById;

export const entityConfigFiltros = (key: string) => createSelector(byId(key), e => {
  if (!e) return null;
  if (e.personalizarFiltros === false) return null;
  return e.filtrosVisiveis ?? [];
});
export const entityConfigCamposVisiveis = (key: string) => createSelector(byId(key), e => (e?.camposVisiveis ?? []));
export const entityConfigCamposGrid = (key: string) => createSelector(byId(key), e => (e?.camposGrid?.length ? e?.camposGrid : defaultCamposGrid));
export const entityConfigParametros = (key: string) => createSelector(byId(key), e => (e?.parametros || emptyParametros()));
export const entityConfigIncidentes = (key: string) => createSelector(byId(key), e => (e?.tiposIncidentes || emptyTiposIncidentes()));
export const entityConfigIntegracoes = (key: string) => createSelector(byId(key), e => (e?.listaIntegracoes || []));
export const entityConfigPrestacaoContas = (key: string) => createSelector(byId(key), e => (e?.parametros?.ativaPrestacaoContas || false));
export const entityConfigTrataviva = (key: string) => createSelector(byId(key), e => (e?.parametros?.ativaTratativasIncidentes || false));
export const entityConfig = (key: string) => createSelector(byId(key), e => (e || entityConfigVoid()));
export const entityConfigIndicadores = (key: string) => createSelector(byId(key),
  e => Map(e?.configIndicadores.indicadores || {}).valueSeq().toArray()
);
